import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import {CustomerSupportPhone, CustomerSupportEmail, BrokerageOperationsPhone, BrokerageOperationsEmail} from '../Account/ContactUsPhoneEmail';

export default function ContactUs() {

  return (
    <Container>
      <Row className="justify-content-center">
        <Col>
          <h4 className='contact-info-heading'>Want to Get In Touch With Us?</h4>
          <p className='contact-info-text'>Please contact us using the information below. We have agents standing by ready to assist with your insurance needs.</p>
          <h4 className='contact-info-heading'>Sales Support</h4>
          <Row>
            <Col>
              <h5 className='contact-info-heading'>Phone</h5>
              <p>Please call us at {CustomerSupportPhone()}</p>
            </Col>
            <Col>
              <h5 className='contact-info-heading'>Email</h5>
              <p><a href={"mailto:" + CustomerSupportEmail()}>{CustomerSupportEmail()}</a></p>
            </Col>
          </Row>
          <h4 className='contact-info-heading'>Brokerage Operations Support</h4>
          <Row>
            <Col>
              <h5 className='contact-info-heading'>Phone</h5>
              <p>Please call us at {BrokerageOperationsPhone()}</p>
            </Col>
            <Col>
              <h5 className='contact-info-heading'>Email</h5>
              <p><a href={"mailto:" + BrokerageOperationsEmail()}>{BrokerageOperationsEmail()}</a></p>
            </Col>
          </Row>
          <h4 className='contact-info-heading'>Hours of Operation</h4>
          <p>Monday through Friday 8am ET to 8pm ET</p>
          <h4 className='contact-info-heading'>Company/Location</h4>
          <p>Covr Financial Technologies<br />401 W. Front Street, Ste. 500<br />Boise, ID 83702</p>
        </Col>
      </Row>
    </Container>
  )
}


// WEBPACK FOOTER //
// ./src/components/Contact/ContactUs.js